import type { Feature } from '@luna/gatekeeper';

export const cardUnlock: Feature = {
    enabled: false,
    _description: 'Enables card unlock focus page',
};
